import { DownOutlined, LogoutOutlined } from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/react-hooks";
import {
  Button,
  Col,
  Collapse,
  Dropdown,
  Form,
  Input,
  message,
  Row,
  Steps,
  Tooltip,
  Typography,
  Card,
  Divider,
  Upload,
  notification,
} from "antd";
import React, { useEffect, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useHistory } from "react-router";
import { ShiftTimingForm } from "../../../../Components/Forms/Onboarding/ShiftTiming";
import { Loader } from "../../../../Components/Loader";
import { SkipButton } from "../../../../Components/SkipButton";
import { CustIcon } from "../../../../Components/Svgs";
import {
  INSERT_EMPLOYEES,
  UPDATE_EMPLOYEES,
} from "../../../../Graphql/mutations";
import {
  GET_EMAIL_PHONE_DETAILS,
  GET_LOCATION_EMPLOYEE_DETAILS,
} from "../../../../Graphql/queries";
import {
  generateRandomPassword,
  logout,
} from "../../../../Utils/functions/common";
import "./EmployeeDetailsManagement.less";
import { ExcelRenderer } from "react-excel-renderer";
import { ImportErrorModal } from "../../../../Components/Modals/ImportErrorModal";
import axios from "axios";
import moment from "moment";

const { Title } = Typography;
const { Step } = Steps;

export const EmployeeDetailsManagementPage = () => {
  const history = useHistory();

  const [currentLocationIndex, setCurrentLocationIndex] = useState(null);
  const [shiftTimeDropdownShow, setShiftTimeDropdownShow] = useState({});
  const [form] = Form.useForm();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errors, setImportError] = useState([]);
  const [fileListx, setFile] = useState([]);
  const [filePath, setFilePath] = useState(null);
  const [fileLoader, setFileLoader] = useState(false);
  const [reload, setReload] = useState(false);
  const [phoneDetails, setPhoneDetails] = useState(null);
  const [emailDetails, setEmailDetails] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const {
    data: businessData,
    loading: fetchingData,
    refetch: refetchbusinessData,
    previousData,
  } = useQuery(GET_LOCATION_EMPLOYEE_DETAILS, {
    variables: {
      owner_id: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
  });
  const [REFETCH_GET_EMAIL_PHONE_DETAILS, { data: getEmailPhoneDetails }] =
    useLazyQuery(GET_EMAIL_PHONE_DETAILS, { fetchPolicy: "cache-and-network" });
  const [INSERT_EMPLOYEES_MUTATION, { loading: isInsertingEmployee }] =
    useMutation(INSERT_EMPLOYEES);

  const [UPDATE_EMPLOYEES_MUTATION, { loading: isUpdatingEmployee }] =
    useMutation(UPDATE_EMPLOYEES);

  useEffect(() => {
    if (businessData && !previousData) {
      setCurrentLocationIndex(0);
    }
  }, [businessData]);

  useEffect(() => {
    if (getEmailPhoneDetails?.getUsers) {
      if (getEmailPhoneDetails?.getUsers[0]?.phone == phoneNumber) {
        setPhoneDetails("true");
      } else {
        setPhoneDetails("false");
      }

      if (getEmailPhoneDetails?.getUsers[0]?.email == emailAddress) {
        setEmailDetails("true");
      } else {
        setEmailDetails("false");
      }
    }
  }, [getEmailPhoneDetails]);

  useEffect(() => {
    if (phoneDetails) {
      if (phoneDetails == "true") {
        notification.error({
          message: "Phone number already exists",
          description: "Please check your phone number and try again.",
          duration: 5000,
        });
      }
    }
    if (emailDetails) {
      if (emailDetails == "true") {
        notification.error({
          message: "Email number already exists",
          description: "Please check your email address and try again.",
          duration: 5000,
        });
      }
    }
  }, [phoneDetails, emailDetails]);

  useEffect(() => {
    if (businessData && currentLocationIndex !== null) {
      formatPrefilledFormValuesfromDB(
        businessData.allLocations[currentLocationIndex]
      );
    }
  }, [currentLocationIndex, businessData]);

  useEffect(() => {
    const { REACT_APP_NODE_ENV } = process.env;
    if (businessData) {
      const REACT_API_URL =
        REACT_APP_NODE_ENV === "development"
          ? "https://apidev.sanattest.com"
          : REACT_APP_NODE_ENV === "staging"
          ? "https://apistage.sanattest.com"
          : "https://api.sanattest.com";

      axios({
        url: `${REACT_API_URL}/rest/downloadFile`, //your url
        data: {
          businessData,
        },
        method: "POST",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          setFilePath(url);
          // const link = doc
        })
        .catch((response) => {
          setReload(true);
          // const link = doc
        });
    }
  }, [businessData]);

  const formatPrefilledFormValuesfromDB = (locationData) => {
    locationData.userTypes.forEach((role, roleIndex) => {
      let matchingUser = locationData.existingUserData.filter(
        ({ jobRoleDetails: { role_id } }) => {
          return role_id === role.roleDetails.roleId;
        }
      );
      if (matchingUser.length > 0) {
        matchingUser.forEach((user, index) => {
          form.setFieldsValue({
            [`employee_code_${roleIndex}_${index + 1}`]:
              user.userDetails.employee_code,
            [`firstName_${roleIndex}_${index + 1}`]:
              user.userDetails.first_name,
            [`lastName_${roleIndex}_${index + 1}`]: user.userDetails.last_name,
            [`email_${roleIndex}_${index + 1}`]: user.userDetails.email,
            [`phone_${roleIndex}_${index + 1}`]: user.userDetails.phone,
            [`user_id_${roleIndex}_${index + 1}`]: user.userDetails.user_id,
            [`shift_${roleIndex}_${index + 1}`]: user.userDetails.user_shifts,
          });
        });
      }
    });
  };

  const toggleDropdownForShiftManagement = (dropdownId) => {
    let tempValues = shiftTimeDropdownShow;
    Object.keys(tempValues).forEach((key) => {
      if (key !== dropdownId) {
        tempValues[key] = false;
      }
    });
    tempValues[dropdownId] = !tempValues[dropdownId];
    setShiftTimeDropdownShow((prevValue) => {
      return { ...tempValues };
    });
  };

  const onLocationChange = (type) => {
    // if (!form.isFieldsTouched()) {
    form.resetFields();
    if (type === "next") {
      setCurrentLocationIndex((s) => s + 1);
    }
    if (type === "previous") {
      setCurrentLocationIndex((s) => s - 1);
    }
    // } else {
    //   Modal.confirm({
    //     title: "Warning",
    //     content:
    //       "You have unsaved data for this location, do you wish to continue without saving?",
    //     icon: <ExclamationCircleOutlined />,
    //     onOk() {
    //       form.resetFields();
    //       if (type == "next") {
    //         setCurrentLocationIndex((s) => s + 1);
    //       }
    //       if (type == "previous") {
    //         setCurrentLocationIndex((s) => s - 1);
    //       }
    //     },
    //     okButtonProps: {
    //       type: "primary",
    //     },
    //   });
    // }
  };
  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const props = {
    name: "file",
    action: "//jsonplaceholder.typicode.com/posts/",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
        // message.success(`${info.file.name} file uploaded successfully`);
        setFileLoader(true);
        uploadEmployeeDetail(info.file.originFileObj);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  const validateImportFile = (fields) => {
    if (
      fields.length &&
      fields[0].toString().trim().toLowerCase() === "employee code" &&
      fields[1].trim().toString().toLowerCase() === "first name" &&
      fields[2].toString().trim().toLowerCase() === "last name" &&
      fields[3].toString().trim().toLowerCase() === "email address" &&
      fields[4].toString().trim().toLowerCase() === "country code" &&
      fields[5].toString().trim().toLowerCase() === "phone" &&
      fields[6].toString().trim().toLowerCase() === "location" &&
      fields[7].toString().trim().toLowerCase() === "role"
    ) {
      return true;
    }
    return false;
  };
  const parseDateExcel = (excelTimestamp) => {
    const secondsInDay = 24 * 60 * 60;
    const excelEpoch = new Date(1899, 11, 31);
    const excelEpochAsUnixTimestamp = excelEpoch.getTime();
    const missingLeapYearDay = secondsInDay * 1000;
    const delta = excelEpochAsUnixTimestamp - missingLeapYearDay;
    const excelTimestampAsUnixTimestamp = excelTimestamp * secondsInDay * 1000;
    const parsed = excelTimestampAsUnixTimestamp + delta;
    return isNaN(parsed) ? null : moment(new Date(parsed)).format("HH:mm:ss");
  };
  const uploadEmployeeDetail = async (file) => {
    let insertUsers = [];
    let errorObj = [];
    ExcelRenderer(file, async (err, resp) => {
      setFileLoader(false);
      if (err) {
        console.log(err);
      } else {
        const isValid = await validateImportFile(resp?.rows[1] || []);
        if (!isValid) {
          message.error("Invalid file selected to import employee data!");
          return "";
        }
        const businessDataTemp = JSON.parse(JSON.stringify(businessData));
        resp.rows.map((data, index) => {
          if (index > 3 && data.length) {
            let isShiftError = false;
            if (
              !data[0] &&
              !data[1] &&
              !data[2] &&
              !data[3] &&
              !data[4] &&
              !data[5] &&
              !data[6] &&
              !data[7] &&
              ((!data[8] && !data[9]) ||
                (!data[10] && !data[11]) ||
                (!data[12] && !data[13]) ||
                (!data[14] && !data[15]) ||
                (!data[16] && !data[17]) ||
                (!data[18] && !data[19]) ||
                (!data[20] && !data[21]))
            ) {
              return "";
            }
            if (!data[0]) {
              const obj = {};
              obj.description = "Employee Code is missing!";
              obj.index = index + 1;
              obj.field = "Employee Code";
              errorObj.push(obj);
            }
            if (!data[1]) {
              const obj = {};
              obj.description = "First name is missing!";
              obj.index = index + 1;
              obj.field = "First Name";
              errorObj.push(obj);
            }
            if (!data[2]) {
              const obj = {};
              obj.description = "Last name is missing!";
              obj.index = index + 1;
              obj.field = "Last Name";
              errorObj.push(obj);
            }
            if (!data[3]) {
              const obj = {};
              obj.description = "Email address is missing!";
              obj.index = index + 1;
              obj.field = "Email Address";
              errorObj.push(obj);
            }
            if (!data[4]) {
              const obj = {};
              obj.description = "Country Code is missing!";
              obj.index = index + 1;
              obj.field = "Country Code";
              errorObj.push(obj);
            }
            if (!data[5]) {
              const obj = {};
              obj.description = "Phone number is missing!";
              obj.index = index + 1;
              obj.field = "Phone";
              errorObj.push(obj);
              return errorObj;
            }
            if (
              !data[8] &&
              !data[9] &&
              data[8] !== 0 &&
              data[9] !== 0 &&
              !data[10] &&
              !data[11] &&
              data[10] !== 0 &&
              data[11] !== 0 &&
              !data[12] &&
              !data[13] &&
              data[12] !== 0 &&
              data[13] !== 0 &&
              !data[14] &&
              !data[15] &&
              data[14] !== 0 &&
              data[15] !== 0 &&
              !data[16] &&
              !data[17] &&
              data[16] !== 0 &&
              data[17] !== 0 &&
              !data[18] &&
              !data[19] &&
              data[18] !== 0 &&
              data[19] !== 0 &&
              !data[20] &&
              !data[21] &&
              data[20] !== 0 &&
              data[21] !== 0
            ) {
              const obj = {};
              obj.description = "Shift Timings missing!";
              obj.index = index + 1;
              obj.field = "Shift Timing";
              errorObj.push(obj);
              isShiftError = true;
              return errorObj;
            }
            let count = 0;
            let roleIndex,
              userCount,
              role,
              temperror = {},
              locationIndex;

            const locationcount = businessDataTemp.allLocations.map((itm) => {
              return itm.location_name === data[6] ? count++ : "";
            });
            locationIndex = businessDataTemp.allLocations.findIndex(
              (itm) => itm.location_name === data[6]
            );
            if (locationIndex < 0) {
              const obj = {};
              obj.description = "Location does not exist!";
              obj.index = index + 1;
              obj.field = "Location";
              errorObj.push(obj);
              return errorObj;
            }
            if (count === 1) {
              roleIndex = businessDataTemp.allLocations[
                locationIndex
              ].userTypes.findIndex(
                (itm) => itm.roleDetails.roleName === data[7].replace(/_/g, ",")
              );

              if (roleIndex < 0) {
                const obj = {};
                obj.description = "Invalid role for selected location!";
                obj.index = index + 1;
                obj.field = "Role";
                errorObj.push(obj);
                return errorObj;
              }

              if (
                businessDataTemp.allLocations[locationIndex].userTypes[
                  roleIndex
                ].count <= 0
              ) {
                const obj = {};
                obj.description = "User Limit Exceeded!";
                obj.index = index + 1;
                obj.field = "Employee Count";
                errorObj.push(obj);
                return errorObj;
              }
              role =
                businessDataTemp.allLocations[locationIndex].userTypes[
                  roleIndex
                ].roleDetails.roleId;
              userCount = businessDataTemp.allLocations[
                locationIndex
              ].existingUserData.filter(
                (itm) => itm.jobRoleDetails.role_id === role
              ).length;
              if (
                userCount ===
                businessDataTemp.allLocations[locationIndex].userTypes[
                  roleIndex
                ].count
              ) {
                const obj = {};
                obj.description = "User Limit Exceeded for this role!";
                obj.index = index + 1;
                obj.field = "Employee Count";
                errorObj.push(obj);
                return errorObj;
              }
            } else if (count > 1) {
              businessDataTemp.allLocations.map((itm, index) => {
                if (itm.location_name === data[6]) {
                  temperror = [];
                  roleIndex = businessDataTemp.allLocations[
                    index
                  ].userTypes.findIndex(
                    (itm) =>
                      itm.roleDetails.roleName === data[7].replace(/_/g, ",")
                  );
                  locationIndex = index;
                  if (roleIndex < 0) {
                    const obj = {};
                    obj.description = "Invalid role for selected location!";
                    obj.index = index + 1;
                    obj.field = "Role";
                    temperror = obj;
                    return null;
                  }
                  if (
                    businessDataTemp.allLocations[index].userTypes[roleIndex]
                      .count <= 0
                  ) {
                    const obj = {};
                    obj.description = "User Limit Exceeded!";
                    obj.index = index + 1;
                    obj.field = "Employee Count";
                    temperror = obj;
                    return null;
                  }
                  role =
                    businessDataTemp.allLocations[index].userTypes[roleIndex]
                      .roleDetails.roleId;
                  userCount = businessDataTemp.allLocations[
                    index
                  ].existingUserData.filter(
                    (itm) => itm.jobRoleDetails.role_id === role
                  ).length;
                  if (
                    userCount ===
                    businessDataTemp.allLocations[index].userTypes[roleIndex]
                      .count
                  ) {
                    const obj = {};
                    obj.description = "User Limit Exceeded for this role!";
                    obj.index = index + 1;
                    obj.field = "Employee Count";
                    temperror = obj;
                    return null;
                  }
                }
              });
            }
            if (
              !isValidPhoneNumber(`+${data[4].toString()}${data[5].toString()}`)
            ) {
              const obj = {};
              obj.description = "Please enter valid phone number!";
              obj.index = index + 1;
              obj.field = "Phone Number";
              errorObj.push(obj);
            }
            const businessShift = [];
            const startTime =
              businessDataTemp?.allLocations[locationIndex]?.workingHours[0]
                ?.opening_time;
            const endTime =
              businessDataTemp?.allLocations[locationIndex]?.workingHours[0]
                ?.closing_time;
            if ((data[8] && data[9]) || data[8] === 0 || data[9] === 0) {
              if (
                parseDateExcel(data[8]) &&
                parseDateExcel(data[9]) &&
                parseDateExcel(data[8]) >= startTime &&
                parseDateExcel(data[8]) <= endTime &&
                parseDateExcel(data[9]) >= startTime &&
                parseDateExcel(data[9]) <= endTime
              ) {
                const shiftObj = {};
                shiftObj.working_day = "Monday";
                shiftObj.start_time = parseDateExcel(data[8]);
                shiftObj.end_time = parseDateExcel(data[9]);
                businessShift.push(shiftObj);
              } else {
                const obj = {};
                obj.description = "Invalid Shift Timings entered for monday!";
                obj.index = index + 1;
                obj.field = "Shift Timing";
                errorObj.push(obj);
              }
            }
            if ((data[10] && data[11]) || data[10] === 0 || data[11] === 0) {
              if (
                parseDateExcel(data[10]) &&
                parseDateExcel(data[11]) &&
                parseDateExcel(data[10]) >= startTime &&
                parseDateExcel(data[10]) <= endTime &&
                parseDateExcel(data[11]) >= startTime &&
                parseDateExcel(data[11]) <= endTime
              ) {
                const shiftObj = {};
                shiftObj.working_day = "Tuesday";
                shiftObj.start_time = parseDateExcel(data[10]);
                shiftObj.end_time = parseDateExcel(data[11]);
                businessShift.push(shiftObj);
              } else {
                const obj = {};
                obj.description = "Invalid Shift Timings entered for tuesday!";
                obj.index = index + 1;
                obj.field = "Shift Timing";
                errorObj.push(obj);
              }
            }
            if ((data[12] && data[13]) || data[12] === 0 || data[13] === 0) {
              if (
                parseDateExcel(data[12]) &&
                parseDateExcel(data[13]) &&
                parseDateExcel(data[12]) >= startTime &&
                parseDateExcel(data[12]) <= endTime &&
                parseDateExcel(data[13]) >= startTime &&
                parseDateExcel(data[13]) <= endTime
              ) {
                const shiftObj = {};
                shiftObj.working_day = "Wednesday";
                shiftObj.start_time = parseDateExcel(data[12]);
                shiftObj.end_time = parseDateExcel(data[13]);
                businessShift.push(shiftObj);
              } else {
                const obj = {};
                obj.description =
                  "Invalid Shift Timings entered for wednesday!";
                obj.index = index + 1;
                obj.field = "Shift Timing";
                errorObj.push(obj);
              }
            }
            if ((data[14] && data[15]) || data[14] === 0 || data[15] === 0) {
              if (
                parseDateExcel(data[14]) &&
                parseDateExcel(data[15]) &&
                parseDateExcel(data[14]) >= startTime &&
                parseDateExcel(data[14]) <= endTime &&
                parseDateExcel(data[15]) >= startTime &&
                parseDateExcel(data[15]) <= endTime
              ) {
                const shiftObj = {};
                shiftObj.working_day = "Thursday";
                shiftObj.start_time = parseDateExcel(data[14]);
                shiftObj.end_time = parseDateExcel(data[15]);
                businessShift.push(shiftObj);
              } else {
                const obj = {};
                obj.description = "Invalid Shift Timings entered for thursday!";
                obj.index = index + 1;
                obj.field = "Shift Timing";
                errorObj.push(obj);
              }
            }
            if ((data[16] && data[17]) || data[16] === 0 || data[17] === 0) {
              if (
                parseDateExcel(data[16]) &&
                parseDateExcel(data[17]) &&
                parseDateExcel(data[16]) >= startTime &&
                parseDateExcel(data[16]) <= endTime &&
                parseDateExcel(data[17]) >= startTime &&
                parseDateExcel(data[17]) <= endTime
              ) {
                const shiftObj = {};
                shiftObj.working_day = "Friday";
                shiftObj.start_time = parseDateExcel(data[16]);
                shiftObj.end_time = parseDateExcel(data[17]);
                businessShift.push(shiftObj);
              } else {
                const obj = {};
                obj.description = "Invalid Shift Timings entered for friday!";
                obj.index = index + 1;
                obj.field = "Shift Timing";
                errorObj.push(obj);
              }
            }
            if ((data[18] && data[19]) || data[18] === 0 || data[19] === 0) {
              if (
                parseDateExcel(data[18]) &&
                parseDateExcel(data[19]) &&
                parseDateExcel(data[18]) >= startTime &&
                parseDateExcel(data[18]) <= endTime &&
                parseDateExcel(data[19]) >= startTime &&
                parseDateExcel(data[19]) <= endTime
              ) {
                const shiftObj = {};
                shiftObj.working_day = "Saturday";
                shiftObj.start_time = parseDateExcel(data[18]);
                shiftObj.end_time = parseDateExcel(data[19]);
                businessShift.push(shiftObj);
              } else {
                const obj = {};
                obj.description = "Invalid Shift Timings entered for saturday!";
                obj.index = index + 1;
                obj.field = "Shift Timing";
                errorObj.push(obj);
              }
            }
            if ((data[20] && data[21]) || data[20] === 0 || data[21] === 0) {
              if (
                parseDateExcel(data[20]) &&
                parseDateExcel(data[21]) &&
                parseDateExcel(data[20]) >= startTime &&
                parseDateExcel(data[20]) <= endTime &&
                parseDateExcel(data[21]) >= startTime &&
                parseDateExcel(data[21]) <= endTime
              ) {
                const shiftObj = {};
                shiftObj.working_day = "Sunday";
                shiftObj.start_time = parseDateExcel(data[20]);
                shiftObj.end_time = parseDateExcel(data[21]);
                businessShift.push(shiftObj);
              } else {
                const obj = {};
                obj.description = "Invalid Shift Timings entered for sunday!";
                obj.index = index + 1;
                obj.field = "Shift Timing";
                errorObj.push(obj);
                return errorObj;
              }
            }
            if (businessShift.length === 0 && !isShiftError) {
              const obj = {};
              obj.description = "Shift Timings missing!";
              obj.index = index + 1;
              obj.field = "Shift Timing";
              errorObj.push(obj);
              return errorObj;
            }
            if (temperror.index) {
              errorObj.push(temperror);
            }
            if (errorObj.length === 0) {
              businessDataTemp.allLocations[locationIndex].userTypes[
                roleIndex
              ].count -= 1;
            }
            insertUsers.push({
              email: data[3],
              employee_code: data[0].toString(),
              first_name: data[1],
              last_name: data[2],
              phone: `+${data[4].toString()}${data[5].toString()}`,
              password: generateRandomPassword(),
              user_location_maps: [
                {
                  business_id: businessDataTemp.businesses[0].business_id,
                  location_id:
                    businessDataTemp.allLocations[locationIndex].location_id,
                  job_role_id: role,
                },
              ],
              user_shifts: businessShift,
            });
          }
          return errorObj;
        });
        try {
          if (errorObj.length > 0) {
            setImportError(errorObj);
            setShowSuccessModal(true);
            return "";
          }
          if (errorObj.length === 0 && insertUsers.length === 0) {
            message.error(
              "No valid data exist in the file, Please enter data and try again!"
            );
            return "";
          }
          const isInsertSuccessful = await INSERT_EMPLOYEES_MUTATION({
            variables: {
              objects: insertUsers,
            },
          });
          if (!isInsertSuccessful.errors) {
            message.success("Employee Data Saved");
            window.location.reload();
          } else {
            message.error(
              "We couldn't save the user details. Please verify the data. If issue persists, contact support!"
            );
          }
        } catch (error) {
          message.error(
            "We couldn't save the user details. Please verify the data. If issue persists, contact support!"
          );
        }
      }
    });
  };
  const onSaveClick = async (values) => {
    let insertUsers = [];
    let updateUsers = [];
    businessData.allLocations[currentLocationIndex].userTypes.forEach(
      (role, role_id) => {
        [...Array(role.count)].forEach((_employee, countIndex) => {
          let id = countIndex + 1;
          let isExist = null;
          isExist = businessData?.allLocations[
            currentLocationIndex
          ]?.existingUserData.find(
            (o) => o.userDetails.email === values[`email_${role_id}_${id}`]
          );
          if (!values[`user_id_${role_id}_${id}`]) {
            insertUsers.push({
              email: values[`email_${role_id}_${id}`],
              employee_code: values[`employee_code_${role_id}_${id}`],
              first_name: values[`firstName_${role_id}_${id}`],
              last_name: values[`lastName_${role_id}_${id}`],
              phone: values[`phone_${role_id}_${id}`],
              password: generateRandomPassword(),
              user_location_maps: [
                {
                  business_id: businessData.businesses[0].business_id,
                  job_role_id: role.roleDetails.roleId,
                  location_id:
                    businessData.allLocations[currentLocationIndex].location_id,
                },
              ],
              user_shifts: values[`shift_${role_id}_${id}`],
            });
          } else {
            values[`shift_${role_id}_${id}`].forEach((s, index) => {
              delete s.__typename;
              s.user_id = values[`user_id_${role_id}_${id}`];
            });

            if (isExist?.userDetails) {
              updateUsers.push({
                user_details: {
                  employee_code: values[`employee_code_${role_id}_${id}`],
                  first_name: values[`firstName_${role_id}_${id}`],
                  last_name: values[`lastName_${role_id}_${id}`],
                  phone: values[`phone_${role_id}_${id}`],
                },
                user_shifts: values[`shift_${role_id}_${id}`],
                user_id: values[`user_id_${role_id}_${id}`],
              });
            } else {
              updateUsers.push({
                user_details: {
                  email: values[`email_${role_id}_${id}`],
                  employee_code: values[`employee_code_${role_id}_${id}`],
                  first_name: values[`firstName_${role_id}_${id}`],
                  last_name: values[`lastName_${role_id}_${id}`],
                  phone: values[`phone_${role_id}_${id}`],
                  password: generateRandomPassword(),
                },
                user_shifts: values[`shift_${role_id}_${id}`],
                user_id: values[`user_id_${role_id}_${id}`],
              });
            }
          }
        });
      }
    );
    try {
      const isInsertSuccessful = await INSERT_EMPLOYEES_MUTATION({
        variables: {
          objects: insertUsers,
        },
      });
      const isUpdateSuccessful = Promise.all(
        updateUsers.map(async (singleUser) => {
          let isUserUpdateSuccess = await UPDATE_EMPLOYEES_MUTATION({
            variables: {
              user_id: singleUser.user_id,
              user_details: singleUser.user_details,
              user_shifts: singleUser.user_shifts,
            },
          });
          if (!isUserUpdateSuccess.errors) {
            return true;
          } else {
            return false;
          }
        })
      );
      if (
        !isInsertSuccessful.errors &&
        !(await isUpdateSuccessful).includes(false)
      ) {
        await refetchbusinessData();
        message.success("Employee Data Saved");
        if (businessData.allLocations.length > currentLocationIndex + 1) {
          form.resetFields();
          setCurrentLocationIndex((s) => s + 1);
        } else {
          message.success("All Employees saved");
          history.push("/on-boarding/employee-reporting");
        }
      } else {
        message.error(
          "We couldn't save the user details. Please verify the data. If issue persists, contact support!"
        );
      }
    } catch (error) {
      message.error(
        "We couldn't save the user details. Please verify the data. If issue persists, contact support!"
      );
    }
  };

  if (
    fetchingData ||
    !businessData ||
    currentLocationIndex === null ||
    (filePath === null && !reload)
  ) {
    return (
      <div className="onBoardingRight">
        <Loader />
      </div>
    );
  }

  const onPhoneChange = (phone) => {
    REFETCH_GET_EMAIL_PHONE_DETAILS({
      variables: {
        phone: phone,
      },
    });
    setPhoneNumber(phone);
  };

  const onEmailChange = (email) => {
    REFETCH_GET_EMAIL_PHONE_DETAILS({
      variables: {
        email: email,
      },
    });
    setEmailAddress(email);
  };

  return (
    <div className="onBoardingRight">
      <ImportErrorModal
        closeModal={() => {
          setShowSuccessModal(false);
          history.push("/on-boarding/employee-details");
        }}
        visible={showSuccessModal}
        errorDetail={errors}
      />
      <div className="employeeRoles employeesManagement">
        <div className="pl-lg-5">
          <div className="d-flex justify-content-between align-items-start">
            <Title level={2}>
              <CustIcon type="left-arrow" onClick={() => history.goBack()} />
              Add all your employees on selected employment roles
            </Title>
            <div
              className="d-flex align-items-center cursorPointer txtdark"
              onClick={() => logout()}
            >
              <CustIcon type="logout-alt" className="fz-18" />
              <span className="pl-2">Logout</span>
            </div>
          </div>
        </div>

        {!reload ? (
          <section className="uploadSec">
            <div>
              <p className="subTitle">
                <b>Too many employees?</b> Upload the data through .xls
                template.
              </p>
            </div>
            <div className="upload_blk">
              <Card className="uploadCard">
                <div>
                  <CustIcon type="logout-alt" className="fz-22 pb-2" />
                </div>
                <div className="pt-3 font-weight-500">
                  Choose the file for filling up your employees data
                </div>
                <div className="fz-10 pt-2 pb-3">
                  Only .xls and .xlsx formats are supported.Maximum upload file
                  size is 5 MB.
                </div>

                {/* <Upload accept=".xls, .xlsx" {...props} maxCount={1} customRequest={dummyRequest}> */}
                <Upload
                  accept=".xls, .xlsx"
                  {...props}
                  maxCount={1}
                  customRequest={dummyRequest}
                >
                  <Button
                    disabled={isInsertingEmployee || isUpdatingEmployee}
                    shape="round"
                    size="large"
                    className="px-5"
                  >
                    Upload
                  </Button>
                </Upload>
                <div className="pt-3">
                  <a
                    className="text-secondary"
                    href={filePath}
                    download="file.xlsx"
                  >
                    Download Sample Template
                  </a>
                </div>
              </Card>
            </div>

            <Divider>Or</Divider>
          </section>
        ) : (
          <></>
        )}
        <Steps current={currentLocationIndex} className="nameOfLocationStep">
          <Step
            key={currentLocationIndex}
            title={
              businessData.allLocations[currentLocationIndex].location_name
            }
          />
        </Steps>
        <div className="location-steps-content">
          <Collapse defaultActiveKey={[0]} accordion>
            {businessData.allLocations[currentLocationIndex].userTypes.map(
              (role, roleIndex) => {
                return (
                  <Collapse.Panel
                    key={roleIndex}
                    header={role.roleDetails.roleName}
                    forceRender={true}
                  >
                    {[...Array(role.count)].map((_employee, countIndex) => {
                      let id = countIndex + 1;
                      let role_id = roleIndex;

                      return (
                        <div className="enterEmployeeDetails" key={countIndex}>
                          <div className="employeetitle" title="1. Employee">
                            <div className="employeeNumber">{id}</div> Employee
                          </div>
                          <Form
                            form={form}
                            name="employeeForm"
                            onFinish={onSaveClick}
                          >
                            <Row gutter={16}>
                              <Col xs={24} sm={12} md={8}>
                                <Tooltip
                                  trigger={["focus"]}
                                  title="Employee Code"
                                  placement="topLeft"
                                  overlayClassName="numeric-input"
                                >
                                  <Form.Item
                                    name={`employee_code_${role_id}_${id}`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Employee Code is required",
                                        whitespace: true,
                                      },
                                    ]}
                                  >
                                    <Input
                                      name="code"
                                      placeholder="Employee Code"
                                    />
                                  </Form.Item>
                                </Tooltip>
                              </Col>
                              <Col xs={24} sm={12} md={8}>
                                <Tooltip
                                  trigger={["focus"]}
                                  title="First Name"
                                  placement="topLeft"
                                  overlayClassName="numeric-input"
                                >
                                  <Form.Item
                                    name={`firstName_${role_id}_${id}`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "First Name is required",
                                        whitespace: true,
                                      },
                                      {
                                        pattern: new RegExp(
                                          "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                                        ),
                                        message: "Invalid First name",
                                      },
                                    ]}
                                  >
                                    <Input
                                      name="firstname"
                                      placeholder="First Name"
                                    />
                                  </Form.Item>
                                </Tooltip>
                              </Col>
                              <Col xs={24} sm={12} md={8}>
                                <Tooltip
                                  trigger={["focus"]}
                                  title="Last Name"
                                  placement="topLeft"
                                  overlayClassName="numeric-input"
                                >
                                  <Form.Item
                                    name={`lastName_${role_id}_${id}`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Last Name is required",
                                        whitespace: true,
                                      },
                                      {
                                        pattern: new RegExp(
                                          "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                                        ),
                                        message: "Invalid Last name",
                                      },
                                    ]}
                                  >
                                    <Input
                                      name="lastname"
                                      placeholder="Last Name"
                                    />
                                  </Form.Item>
                                </Tooltip>
                              </Col>
                              <Col xs={24} sm={12} md={8}>
                                <Tooltip
                                  trigger={["focus"]}
                                  title="Email"
                                  placement="topLeft"
                                  overlayClassName="numeric-input"
                                >
                                  <Form.Item
                                    name={`email_${role_id}_${id}`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Email Address is required",
                                        whitespace: true,
                                      },
                                      {
                                        type: "email",
                                        message: "Enter Valid Email Address",
                                      },
                                    ]}
                                    normalize={(values) => values.toLowerCase()}
                                  >
                                    <Input
                                      name="email"
                                      onBlur={(email) => {
                                        onEmailChange(
                                          email.target.value.replaceAll(" ", "")
                                        );
                                      }}
                                      placeholder="Email"
                                    />
                                  </Form.Item>
                                </Tooltip>
                              </Col>
                              <Col xs={24} sm={12} md={8}>
                                <Tooltip
                                  trigger={["focus"]}
                                  title="Phone"
                                  placement="topLeft"
                                  overlayClassName="numeric-input"
                                >
                                  <Form.Item
                                    name={`phone_${role_id}_${id}`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Phone Number is required",
                                        whitespace: true,
                                      },
                                      () => ({
                                        validator(_, value) {
                                          if (
                                            value &&
                                            isValidPhoneNumber(value)
                                          ) {
                                            return Promise.resolve();
                                          } else {
                                            return Promise.reject(
                                              new Error(
                                                "Enter Valid Phone Number"
                                              )
                                            );
                                          }
                                        },
                                      }),
                                    ]}
                                  >
                                    <PhoneInput
                                      className="phoneInput_blk"
                                      defaultCountry="US"
                                      placeholder="(201) 555-1234"
                                      onBlur={(phone) => {
                                        onPhoneChange(
                                          phone.target.value.replaceAll(" ", "")
                                        );
                                      }}
                                      countryOptionsOrder={[
                                        "US",
                                        "CA",
                                        "|",
                                        "...",
                                      ]}
                                    />
                                  </Form.Item>
                                </Tooltip>
                              </Col>
                              <Col xs={24} sm={12} md={8}>
                                <Form.Item
                                  name={`shift_${role_id}_${id}`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Shift Timing is required",
                                      whitespace: true,
                                      type: "array",
                                    },
                                  ]}
                                >
                                  <Dropdown
                                    name={`shift_dropdown_${role_id}_${id}`}
                                    className="selectShiftTimings"
                                    overlayClassName="selectShiftTimingsPop"
                                    placement="bottomRight"
                                    overlay={
                                      <ShiftTimingForm
                                        openingTime={
                                          businessData.allLocations[
                                            currentLocationIndex
                                          ].workingHours[0].opening_time
                                        }
                                        closingTime={
                                          businessData.allLocations[
                                            currentLocationIndex
                                          ].workingHours[0].closing_time
                                        }
                                        currentRoleIndex={role_id}
                                        currentEmployeeIndex={id}
                                        formInstance={form}
                                        initialValue={form.getFieldValue(
                                          `shift_${role_id}_${id}`
                                        )}
                                        closeDropDown={() => {
                                          toggleDropdownForShiftManagement(
                                            "shift_dropdown_" +
                                              role_id +
                                              "_" +
                                              id
                                          );
                                        }}
                                      />
                                    }
                                    visible={
                                      shiftTimeDropdownShow[
                                        "shift_dropdown_" + role_id + "_" + id
                                      ]
                                    }
                                    onClick={() =>
                                      toggleDropdownForShiftManagement(
                                        "shift_dropdown_" + role_id + "_" + id
                                      )
                                    }
                                  >
                                    <Button
                                      className="ant-dropdown-link"
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      Shift timings
                                      <DownOutlined />
                                    </Button>
                                  </Dropdown>
                                </Form.Item>
                              </Col>
                            </Row>
                            <Form.Item
                              className="d-none"
                              name={`user_id_${role_id}_${id}`}
                            ></Form.Item>
                          </Form>
                        </div>
                      );
                    })}
                  </Collapse.Panel>
                );
              }
            )}
          </Collapse>
        </div>
        <Row justify="space-between">
          <Col lg={8} xs={24} className="d-flex justify-content-center py-2">
            {currentLocationIndex !== 0 && (
              <Button
                disabled={isInsertingEmployee || isUpdatingEmployee}
                shape="round"
                htmlType="button"
                size="large"
                className="px-5"
                onClick={() => onLocationChange("previous")}
              >
                Previous Location
              </Button>
            )}
          </Col>
          <Col lg={8} xs={24} className="d-flex justify-content-center py-2">
            <SkipButton />
            <Button
              loading={isInsertingEmployee || isUpdatingEmployee}
              type="primary"
              shape="round"
              htmlType="button"
              size="large"
              className="px-5"
              onClick={() => {
                form.submit();
              }}
            >
              {isInsertingEmployee || isUpdatingEmployee
                ? "Saving"
                : businessData.allLocations.length !== currentLocationIndex + 1
                ? "Save & Next"
                : "Save & Continue"}
            </Button>
          </Col>
          <Col lg={8} xs={24} className="d-flex justify-content-center py-2">
            {businessData.allLocations.length !== currentLocationIndex + 1 && (
              <Button
                disabled={isInsertingEmployee || isUpdatingEmployee}
                shape="round"
                htmlType="button"
                size="large"
                className="px-5"
                onClick={() => onLocationChange("next")}
              >
                Next Location
              </Button>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};
